/**
 * MobileMenu component for the website.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {Object} props.data - Data used for rendering the Navbar.
 * @returns {JSX.Element} Returns the Navbar component.
 */

import React, { useState } from "react";
import Link from "next/link";
import MobileMenuHamburger from "../../../assets/svg/MobileMenuHamburger";
import MenuMobileClose from "../../../assets/svg/MobileMenuClose";

const MobileMenu = ({ data, overlayTop = 55 }) => {
  const [openMenuMobile, setOpenMenuMobile] = useState(false);

  return (
    <>
      <button
        className={`px-6 hidden mob:flex items-center h-full min-w-[87px] lg:min-w-[143.4px] mob:justify-center  ${openMenuMobile ? "bg-white" : ""}`}
        aria-label={openMenuMobile ? "Close mobile menu" : "Open mobile menu"}
        onClick={() => {
          setOpenMenuMobile(!openMenuMobile);
        }}
      >
        {openMenuMobile ? <MenuMobileClose /> : <MobileMenuHamburger />}
      </button>
      {openMenuMobile && (
        <div
          className={`absolute hidden mob:block bg-white py-6 w-screen h-screen ap-6`}
          style={{ top: `${overlayTop}px` }}
        >
          <ul className={`flex flex-col justify-between gap-3`}>
            <Link href="/product" className={`flex px-6`}>
              <p className="text-[24px]">Explore Matic</p>
            </Link>
            <Link href="/accessories" className={`flex px-6`}>
              <p className="text-[24px]">Shop Accessories</p>
            </Link>
          </ul>
        </div>
      )}
    </>
  );
};

export default MobileMenu;
